import React, { useEffect, useCallback, useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import { CircularProgress } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { isUndefined } from 'lodash';

import { uploadContentService } from '../../services';

import { useHistory } from 'react-router-dom';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#252525",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
    color: theme.palette.common.white,
  },
  button: {
  }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: "#424242",
    },
    '&:nth-of-type(even)': {
      backgroundColor: "#252525",
    },
  },
}))(TableRow);

function createData(SPILLELISTER, BUTTON) {
  return { SPILLELISTER, BUTTON };
}

const useStyles = makeStyles({
  table: {
    maxWidth: 2000,
  },
  button: {
    marginTop: 10,
    height:40,
    width: 80,
    float: 'right',
    fontSize: 15,
    fontWeight: 'bold',
    color: '#ffffff',
    backgroundColor: '#6C6C6C'
  },
  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '2rem 0',
  }
});

export default function CustomizedTables() {
  const classes = useStyles();
  const history = useHistory();

  const [taggedPlaylists, setTaggedPlaylists] = useState([]);
  const { user } = useSelector(state => state.userAuthentication);
  
  const handleRedirectToPage = (event) => {
    if (event.currentTarget.dataset.value === "tagged-playlist-detail") {
      history.push({
        pathname: '/tagged-playlist-detail',
        state: { id: event.currentTarget.dataset.id }
      });
      window.location.reload();
    }
  }

  const getTaggedPlaylists = useCallback(async () => {
    if (!isUndefined(user)) {
      const res = await uploadContentService.taggedPlaylists(user);
      setTaggedPlaylists(res?.items);
    }
  }, [user]);

  useEffect(() => {
    getTaggedPlaylists();
  }, [getTaggedPlaylists]);

  return (
    <div>
      <span className="span-design">
        <div className="icon-design"><LocalOfferIcon /> Tagged </div>
        <h3 className="text-design">  Playlist</h3>
      </span>
      <TableContainer component={Paper} className={classes.table}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="left">PLAYLIST</StyledTableCell>
              <StyledTableCell align="right">&nbsp;</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!isUndefined(taggedPlaylists) ? (
              [...taggedPlaylists].map(item => (
                <StyledTableRow key={item.name} >
                  <StyledTableCell align="left">{item.name}</StyledTableCell>
                  <StyledTableCell align="left"> <Button
                    onClick={handleRedirectToPage}
                    variant="contained"
                    startIcon={<EditIcon />}
                    data-value="tagged-playlist-detail"
                    data-id={item.id}
                    className={classes.button}
                  >
                    EDIT 
                  </Button></StyledTableCell>

                </StyledTableRow>
              ))
            ) : (
              <div className={classes.loader}>
                <CircularProgress />
              </div>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}